import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from '../../../../../firebase/src/lib/services/auth.service';
import {AuthComponent} from '../auth/auth.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { getAuth, isSignInWithEmailLink} from '@angular/fire/auth';
import {SsoModalComponent} from './sso-modal/sso-modal.component';
import {LanguageService} from '../../services/language.service';
import {environment} from '../../../environments/environment';

@Component({
    selector: 'app-sso',
    templateUrl: './sso.component.html',
    styleUrls: ['./sso.component.scss']
})
export class SSOComponent implements OnInit {
    apiUrl = environment.apiUrl;

    constructor(
        private router: Router,
        private modalService: NgbModal,
        public auth: AuthService,
        private language: LanguageService
    ) {
    }

    ngOnInit(): void {
        const auth = getAuth();
        if (isSignInWithEmailLink(auth, window.location.href) && !this.auth?.isLoggedIn) {
            this.openSsoAuthModal(window.location.href)
                .then((res: any) => {
                    if (res === 'SIGN_IN') {
                        return this.openAuthModal();
                    }
                    return true;
                })
                .then(() => {
                    return this.router.navigate(['/']);
                });
        } else if (this.auth?.isLoggedIn) {

            // const navigateToLanguage = environment.defaultLanguage === this.language.getUserLang() ? '' : this.language.currentLanguage;
            // this.router.navigate(['/']);
        }
    }

    openAuthModal(): Promise<boolean> {
        const modalRef = this.modalService.open(AuthComponent, {
            centered: true,
            size: 'md',
            windowClass: 'modal login',
            backdrop: 'static',
            keyboard: true
        });
        return modalRef.result;
    }

    openSsoAuthModal(prop: any): Promise<any> {
        const modalRef = this.modalService.open(SsoModalComponent, {
            centered: true,
            size: 'md',
            windowClass: 'modal login',
            backdrop: 'static',
            keyboard: true
        });
        modalRef.componentInstance.data = prop;
        return modalRef.result;
    }
}
